import { useMemo, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { ConversationList, MessageThread } from '../../components/workflows/ConversationList'
import { useAppStore } from '../../store/AppStore'

export function MessagesPage() {
  const { state, sendMessage } = useAppStore()
  const [params, setParams] = useSearchParams()
  const role = state.currentUser?.role ?? 'company'
  const conversations = useMemo(() => state.conversations.filter((conversation) => role === 'admin' || (role === 'athlete' ? conversation.athleteId === state.currentUser?.athleteId : conversation.companyId === state.currentUser?.companyId)), [state.conversations, state.currentUser, role])
  const initial = params.get('conversation') ?? conversations[0]?.id
  const [activeId, setActiveId] = useState(initial)
  const active = conversations.find((conversation) => conversation.id === activeId)
  const select = (id: string) => { setActiveId(id); setParams({ conversation: id }) }
  return <div className="messaging-layout"><ConversationList conversations={conversations} activeId={activeId} role={role} onSelect={select} /><MessageThread conversation={active} onSend={(body) => activeId && sendMessage(activeId, body)} /></div>
}
